import { Button, DialogActions, DialogContent, DialogTitle, TunaDialog, useDimensions } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useId } from 'react'
import { StageSetupEditor } from './stage-setup-editor.js'

export interface StageSetupDialogProps {
  open: boolean
  band: { id: string; name: string }
  /** Whether the viewer has said they don't perform with this band */
  notPerforming: boolean
  onPerformingChange(performs: boolean): void
  onClose(): void
}

/**
 * The stage setup editor for one band, from the band page or the rider: a 2-minute task does not send the member
 * away to a profile tab. Full-screen on phones. Escape closes it; focus returns to the button that opened it.
 */
export const StageSetupDialog: FC<StageSetupDialogProps> = props => {
  const { open, band, notPerforming, onPerformingChange, onClose } = props
  const titleId = useId()
  const { isSmallOrSmaller } = useDimensions()

  const handleOptOut = () => {
    onPerformingChange(false)
    onClose()
  }

  return (
    <TunaDialog
      open={open}
      onClose={onClose}
      fullScreen={isSmallOrSmaller}
      maxWidth="md"
      fullWidth
      aria-labelledby={titleId}
    >
      <DialogTitle id={titleId} onClose={onClose}>
        Stage setup
      </DialogTitle>
      <DialogContent>
        <StageSetupEditor band={band} />
      </DialogContent>
      <DialogActions>
        {notPerforming ? (
          <Button color="inherit" onClick={() => onPerformingChange(true)}>
            I perform with {band.name}
          </Button>
        ) : (
          <Button color="inherit" onClick={handleOptOut}>
            I don&apos;t perform with {band.name}
          </Button>
        )}
        <Button variant="contained" onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </TunaDialog>
  )
}

export default StageSetupDialog
